<template>
  <section class="query-box">
    <el-row justify="start" align="middle" :gutter="32">
      <el-col :span="4">
        <el-select-v2
          v-model="type"
          :options="typeOptions"
          style="width: 80px"
          placeholder="请选择"
        ></el-select-v2>
      </el-col>
      <el-col :span="12">
        <el-date-picker
          v-model="day_date"
          style="width: 200px"
          type="daterange"
          v-if="type === 1"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
        <el-date-picker
          v-model="month_date"
          type="month"
          v-else-if="type === 2"
          placeholder="请选择日期"
        />
        <el-date-picker
          v-model="month_date"
          type="month"
          v-else-if="type === 4"
          placeholder="请选择日期"
          @change="monthChange"
        />
        <el-date-picker
          v-model="year_date"
          v-else
          type="year"
          placeholder="请选择日期"
        />
      </el-col>
    </el-row>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  typeOptions: {
    type: Array,
    default: [
      {
        label: '日',
        value: 1,
      },
      {
        label: '月',
        value: 2,
      },
      {
        label: '季',
        value: 4,
      },
      {
        label: '年',
        value: 3,
      },
    ],
  },
})
const type = ref(1)

// 季报选择
function monthChange(e) {
  console.log(e, 'e========')
}
</script>

<style lang="scss" scoped></style>
